// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD3NzD51g67LOucqph7GXlCQ7rVHyHLRqY",
  authDomain: "brkozcn-id.firebaseapp.com",
  databaseURL:
    "https://brkozcn-id-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "brkozcn-id",
  storageBucket: "brkozcn-id.appspot.com",
  messagingSenderId: "444516682008",
  appId: "1:444516682008:web:7c0795b062656d43efb66d",
  measurementId: "G-HGMC9LFNQ1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);
export default db;
